import { Collapse, IconButton } from '@mui/material';
import React, { FC, useState } from 'react';
import styled from 'styled-components';
import StyledStatus from './StyledStatus';
import { CommentIconBlack, GalleryIcon } from '@src/components/Icons';
import { OrderProduct } from '../acceptDelivery';
import { useAppDispatch } from '@src/store/hooks';
import { setPreviewImages } from '@src/store/reducers/UIReducer';

const StyledProductCard = styled.div`
	width: 95%;
	height: auto;
	background: white;
	display: flex;
	flex-direction: column;
	border-radius: 10px;
	border: 1.5px solid #f1f1f1;
	letter-spacing: 0.28px;
	#top {
		display: flex;
		padding: 10px;
		gap: 14px;
	}
`;

const QuantityContainer = styled.div`
	min-width: 40px;
	min-height: 40px;
	max-height: 40px;
	min-width: 40px;
	background: #fff9e6;
	border-radius: 8px;
	border: 1.5px solid #e9e9e9;
	margin-top: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
`;
const ProductSize = styled.div`
	color: #acacac;
	font-size: 12px;
	font-weight: 600;
`;

const ProductInfoContainer = styled.div`
	width: 100%;
	display: flex;
  justify-content: space-between;
  #product-info{
    display: flex;
    flex-direction: column;
    #status-container{
      display: flex;
      align-items: center;
      gap: 12px;

      span{
        color: var(--default-text-color);
        font-size: 12px;
        font-style: italic;
        font-weight: 600;
        line-height: 20px;
      }
      @media screen and (max-width: 800px) {
        align-items: flex-start;
        flex-direction: column;
        gap: 0px;
      }
    }
  }
  #icons{
    display: flex;
    align-items: center;
  }

	}
`;

const ProductName = styled.div`
	margin-top: 10px;
	color: black;
	font-size: 14px;
	font-weight: 600;
	max-width: 400px;
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	text-overflow: ellipsis;
	word-wrap: break-word;

	@media screen and (max-width: 800px) {
		max-width: 204px;
	}
`;

const ProductPrice = styled.div`
	color: var(--default-text-color);
	font-size: 12px;
	font-weight: 700;
	word-wrap: break-word;
`;

const QuantityText = styled.div`
	color: var(--default-text-color);
	font-size: 16px;
	font-family: 'Nunito Sans';
	font-weight: 600;
	word-wrap: break-word;
`;

const ButtonsContainer = styled.div`
	display: flex;
	align-items: flex-end;
	gap: 10px;

	.icon-container {
		display: flex;
		align-items: center;
		justify-content: center;
		background: #f7f5f4;
		width: 36px;
		height: 36px;
		border-radius: 50%;
		transition: background 0.3s ease;

		&:hover {
			background: #d1d1d1;
		}

		&:active {
			background: #a1a1a1;
		}
	}
`;

const CommentContainer = styled.div`
	color: var(--default-text-color);
	font-size: 12px;
	font-style: italic;
	font-weight: 600;
	line-height: 17.6px;
`;

interface Props {
	product: OrderProduct;
}

const ProductSummaryCard: FC<Props> = ({ product }) => {
	const [isShowComment, setIsShowComment] = useState(false);
	const isAccepted = product?.delivery_acc_status?.toLowerCase() === 'accepted';
	const dispatch = useAppDispatch();

	const openPreview = () => {
		dispatch(setPreviewImages([product?.delivery_acc_image]));
	};

	return (
		<StyledProductCard>
			<div id="top">
				<QuantityContainer>
					<QuantityText>{product?.quantity}</QuantityText>
				</QuantityContainer>
				<ProductInfoContainer>
					<div id="product-info">
						<ProductName>{product?.name}</ProductName>
						<div id="status-container">
							<StyledStatus status={product?.delivery_acc_status?.toLowerCase()} />
							{!isAccepted ? (
								product?.delivery_acc_reason?.toLowerCase() === 'other' ? (
									<span>other reason</span>
								) : (
									<span>
										{product?.delivery_acc_quantity} {product?.delivery_acc_reason}
									</span>
								)
							) : null}
						</div>
					</div>

					<div id="icons">
						{!isAccepted && product?.delivery_acc_image ? (
							<IconButton onClick={openPreview}>
								<GalleryIcon />
							</IconButton>
						) : null}
						{product?.delivery_acc_comments ? (
							<IconButton onClick={() => setIsShowComment(!isShowComment)}>
								<CommentIconBlack />
							</IconButton>
						) : null}
					</div>
				</ProductInfoContainer>
			</div>
			<Collapse
				in={isShowComment}
				style={{ marginLeft: '64px', marginRight: '8px', paddingBottom: '4px' }}
			>
				<CommentContainer>“{product?.delivery_acc_comments}”</CommentContainer>
			</Collapse>
		</StyledProductCard>
	);
};

export default ProductSummaryCard;
